import { AddToSCBreakList } from "../utils/AddToSCBreakList";
import { CreateBoxPair } from "../utils/CreateBoxPair";
import { enumSubChartFlag, kCBBoxLayoutContent, kCBChartBoxContent } from "../constants";
import { QBoxDataPair } from "./QBoxDataPair";
import { QChartContent } from "./QChartContent";
import { QClipboard } from "./QClipboard";
import { ClipboardFindNewObj } from "../utils/ClipboardFindNewObj.js";
import { AddToBaseList } from "../utils/AddToBaseList.js";

export class QXClipboard extends QClipboard {
  constructor() {
    //this.fSetToPersist = false;
    super();
  }

  InitXClipboard() {
    this.InitClipboard();
  }

  AddChildrenObjs(clipData, childPairs, parentObj, boxClass, subChartMgr, breakList, branchStyle) {
    // Add new db objs and wire hierarchy
    var nC = childPairs.length;
    for (var i = 0; i < nC; i++) {
      var aChild = childPairs[i];
      var layout = aChild.fLayout;
      if (branchStyle != null) layout.SetBranchStyle(branchStyle);

      var scFlag = layout.GetSubChartFlag();

      var serialObj = aChild.fSerialDBObj;
      var objID = serialObj.GetObjectID();
      if (scFlag != enumSubChartFlag.drillup) {
        var dataObj = boxClass.AddNewObject();
        serialObj.RestoreTo(dataObj);
        dataObj.SetParent(parentObj, -1);
        aChild["newobj"] = dataObj;
      }
      aChild["objID"] = objID;
    }

    // Use dbobj created for top of subchart pair
    for (var i = 0; i < nC; i++) {
      var aChild = childPairs[i];
      if (aChild["newobj"] == null)
        aChild["newobj"] = ClipboardFindNewObj(childPairs, aChild["objID"]);
    }

    var tempList = [];

    // Create SC Nodes
    var subChartID = subChartMgr.GetCurrentSubChartID();
    for (var i = 0; i < nC; i++) {
      var aChild = childPairs[i];
      var layout = aChild.fLayout;
      var dataObj = aChild["newobj"];

      layout.SetDBObj(dataObj);
      var newSCNode = subChartMgr.AddSCNode(layout, dataObj, dataObj.GetObjectID());
      layout.SetSCNodeRef(newSCNode);
      if (layout.GetSubChartFlag() !== enumSubChartFlag.drillup) layout.SetSubChartID(subChartID);
      AddToSCBreakList(newSCNode, tempList, breakList);
    }

    // Recurse to the next level
    for (var i = 0; i < nC; i++) {
      var childPair = childPairs[i];
      var nextChildPairs = clipData.GetChildren(childPair);
      if (nextChildPairs != null) {
        var parentObj = childPair["newobj"];
        this.AddChildrenObjs(
          clipData,
          nextChildPairs,
          parentObj,
          boxClass,
          subChartMgr,
          breakList,
          null
        );
      }
    }
  }

  AddClipboardToDoc(objDB, parentObj, subChartMgr, branchStyle) {
    var boxClass = objDB.GetClassByName("Box");
    var clipData = this.GetCopyOfClipboard();

    var breakList = [];
    var roots = clipData.GetRoots();
    this.AddChildrenObjs(clipData, roots, parentObj, boxClass, subChartMgr, breakList, branchStyle);

    // Insert subchart breaks
    var n = breakList.length;
    for (var i = 0; i < n; i++) {
      var breakEntry = breakList[i];
      subChartMgr.ClipboardInsertSubChartBreak(breakEntry.fTopSCNode, breakEntry.fBottomSCNode);
    }
  }

  GetCopyOfClipboard() {
    var curClipboard = this.fCBBuffer;
    var content = curClipboard.GetContent();

    //dumppairs(content, "Clipboard Contents");

    var baseList = new QChartContent();
    baseList.Init();

    var n = content.length;
    for (var i = 0; i < n; i++) {
      var aPair = content[i];
      var newPair = new QBoxDataPair();
      var newLayout = aPair.fLayout;
      var serialObj = aPair.fSerialDBObj;
      //	var serialSC = aPair.fSerialSubChart;

      newPair.InitFromSerialObj(newLayout, serialObj); //, aPair.InTopChart()); //serialSC,
      AddToBaseList(baseList, newPair);
    }

    //	var cloneList = this.CreateCloneList(contentShift);
    //	dumppairs(cloneList, "Copy of Clipboard Contents");

    return baseList;
  }

  DeepCopyNodeList(scNodeList, baseList) {
    // Convert scNodes into a pairlist
    var n = scNodeList.length;
    for (var i = 0; i < n; i++) {
      var scNode = scNodeList[i];
      var newPair = CreateBoxPair(scNode); // ,true);
      AddToBaseList(baseList, newPair);

      var scm = scNode.GetSubChartMgr();
      var dbObj = scNode.GetDataObj();
      var isTop = dbObj.TopOfSubChart();
      if (isTop == 1) {
        if (scNode.BottomOfBreak()) {
          var l = newPair.fLayout;
          l.fSubChartFlag = enumSubChartFlag.nobreak;
        } else {
          var childNodes = scm.GetAllChildSCNodes(dbObj);
          var m = childNodes.length;
          for (var j = 0; j < m; j++) {
            var childNode = childNodes[j];
            var childPair = CreateBoxPair(childNode); //,false);
            AddToBaseList(baseList, childPair);
          }
        }
      }
    }

    return baseList;
  }

  DeepCopy(selectedBoxes) {
    // Convert selectedboxes into a pairlist
    var scNodeList = new Array();
    var n = selectedBoxes.length;
    for (var i = 0; i < n; i++) {
      var aBox = selectedBoxes[i];
      var layout = aBox.GetLayout();
      var scNode = layout.GetSCNodeRef();
      scNodeList.push(scNode);
    }

    var baseList = new QChartContent();
    baseList.Init();

    this.DeepCopyNodeList(scNodeList, baseList);
    return baseList;
  }

  // TODO handle clipboard update field refs (background reload fields)
  RemoveFieldReferences(fieldRefs) {
    var contentType = this.GetContentType();
    if (contentType == kCBBoxLayoutContent) {
      var theLayout = this.GetContent();
      theLayout.RemoveFieldReferences(fieldRefs);
    } else if (contentType == kCBChartBoxContent) {
      var theData = this.GetContent();
      var n = theData.length;
      for (var i = 0; i < n; i++) {
        var theLayout = theData[i].fLayout;
        theLayout.RemoveFieldReferences(fieldRefs);

        var serialObj = theData[i].fSerialDBObj;
        serialObj.RemoveFieldReferences(fieldRefs);
      }
    }
  }
}
